import RestService from './RestService';
import BouncedEmails from './BouncedEmailsService';
import Users from './UsersService';
import buildURL from 'axios/lib/helpers/buildURL';

export default class Automations extends RestService {
    constructor(parentService, parentId) {
        if (parentService && parentId) {
            super(`${parentService.baseUrl}/${parentId}/automations`);
        } else super('/automations');
    }

    //Get latest ten trainings,
    listLatestTen() {
        return this.get(`${this.baseUrl}/latest-ten`);
    }

    //Get trainings for report
    listRecent() {
        return this.get(`${this.baseUrl}/for-report`);
    }

    eventUserStatus(automationId, eventId, email) {
        return this.get(
            `${
                this.baseUrl
            }/${automationId}/status/${eventId}/user/${encodeURIComponent(
                email
            )}`
        );
    }

    userStatus(automationId, email) {
        return this.get(
            `${this.baseUrl}/${automationId}/status2/user/${encodeURIComponent(
                email
            )}`
        );
    }

    chartMetrics(automationId) {
        return this.get(`${this.baseUrl}/${automationId}/chartMetrics`);
    }

    scenarios(automationId, params) {
        return this.get(`${this.baseUrl}/${automationId}/scenarios`, params);
    }

    threatAreas(automationId, params) {
        return this.get(`${this.baseUrl}/${automationId}/threatAreas`, params);
    }

    lists(automationId, params) {
        return this.get(`${this.baseUrl}/${automationId}/lists`, params);
    }

    users(automationId, params) {
        return this.get(`${this.baseUrl}/${automationId}/users`, params);
    }

    remindersOverview(automationId, params) {
        return this.get(`${this.baseUrl}/${automationId}/reminders`, params);
    }

    schedule(automationId) {
        return this.get(`${this.baseUrl}/${automationId}/schedule`);
    }

    updateScheduleEvent(automationId, eventId, data) {
        return this.put(`${this.baseUrl}/${automationId}/schedule/${eventId}`, data);
    }

    userTrainings(email) {
        return this.get(
            `${this.baseUrl}/user-trainings/${encodeURIComponent(email)}`
        );
    }

    resendEventMail(automationId, eventId, email) {
        return this.post(
            `${this.baseUrl}/${automationId}/status/${eventId}/resend`,
            { email }
        );
    }

    loadingRemindersCounter(automationId, reminderOption) {
        return this.post(`${this.baseUrl}/${automationId}/count-reminders`, {
            reminderOption,
        });
    }

    sendReminders(automationId, paramsOrReminderOption, body) {
        if (body) {
            return this.post(
                buildURL(`${this.baseUrl}/${automationId}/reminders`, paramsOrReminderOption),
                body
            );
        }
        return this.post(`${this.baseUrl}/${automationId}/reminders`, {
            reminderOption: paramsOrReminderOption,
        });
    }

    countReminders(automationId, params, body) {
        return this.post(
            buildURL(`${this.baseUrl}/${automationId}/count-reminders`, params),
            body
        );
    }

    employeeLists(automationId, filters, csv = false, options) {
        const params = { ...filters };
        if (csv) params.csv = true;
        return this.get(`${this.baseUrl}/${automationId}/lists`, params, options);
    }

    saveDraft(data) {
        return this.post(`${this.baseUrl}/draft`, data);
    }

    updateDraft(data) {
        return this.put(`${this.baseUrl}/draft/${data.id}`, data);
    }

    switchSyncLists(automationId, disabled) {
        return this.put(`${this.baseUrl}/${automationId}/switchSyncLists`, {
            disabled,
        });
    }

    previewSyncLists(automationId) {
        return this.get(`${this.baseUrl}/${automationId}/previewSyncLists`);
    }

    syncUsers(automationId, data) {
        return this.post(`${this.baseUrl}/${automationId}/syncLists`, data);
    }

    sendPreview(data) {
        return this.post(`${this.baseUrl}/sendPreview`, data);
    }

    loadUsersDetails(automationId, params) {
        return this.get(`${this.baseUrl}/${automationId}/perUsersDetails`, params);
    }

    getSigninLink(automationId, email) {
        return this.get(
            `${this.baseUrl}/${automationId}/signin-link`,
            { email }
        );
    }

    usersService(automationId) {
        return new Users(this, automationId);
    }

    pauseAutomation(automationId) {
        return this.post(`${this.baseUrl}/${automationId}/pauseAutomation`);
    }

    resumeAutomation(automationId) {
        return this.post(`${this.baseUrl}/${automationId}/resumeAutomation`);
    }

    renameAutomation(automationId, data) {
        return this.put(`${this.baseUrl}/${automationId}/name`, data);
    }

    updateDue(automationId, data) {
        return this.put(`${this.baseUrl}/${automationId}/due`, data);
    }

    bouncedEmailsService(automationId) {
        return new BouncedEmails(this, automationId);
    }
}
